import { Controller, useFieldArray } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

import DynamicSelect from "./form-builder-element/select";
import DynamicInput from "./form-builder-element/text";


interface ElementControllerProps {
  formControl: any;
  fieldArrayName: string;
  fields: any[];
  append: (value: any) => void;
  remove: (index: number) => void;
  renderElement: (field: any, index: number) => React.ReactNode;
}

export const ElementController = (props: ElementControllerProps) => {
  const { fields: abjMember, append } = useFieldArray({
    control: props.control,
    name: "abjMember",
  });

  const addAdjMember = (type: string, elementName: string) => {
    switch (type) {
      case "input":
        append({ type: "input", appendAfter: elementName });
        break;
      case "select":
        append({ type: "select", appendAfter: elementName });
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Controller
        control={props.control}
        name={props.name}
        defaultValue={props.defaultValue || ""}
        render={({ field }) => {
          if (
            Object.keys(props.field1).length &&
            Object.keys(props.field1) !== Object.keys(field)
          ) {
            props.updateField({ ...field });
          }
          return props.children;
        }}
      />
      <CloseIcon
        style={{ fontSize: "15px", cursor: "pointer" }}
        onClick={() => addAdjMember("input", props.name)}
      />
      <AddIcon
        style={{ fontSize: "15px", cursor: "pointer" }}
        onClick={() => addAdjMember("select", props.name)}
      />
      {abjMember.map((field: any) => {
        if (field.appendAfter === props.name) {
          return (
            <>
              {field.type === "input" && (
                <DynamicInput
                  placeholder="Enter value"
                  label="Message"
                  formControl={props.control}
                  name="message"
                  fieldArrayName="abjMember"
                />
              )}
              {field.type === "select" && (
                <DynamicSelect
                  placeholder="Select value"
                  label="Is True"
                  options={[
                    { value: "option1", label: "Option 1" },
                    { value: "option2", label: "Option 2" },
                  ]}
                  formControl={props.control}
                  name="is_true"
                  fieldArrayName="abjMember"
                />
              )}
            </>
          );
        }
      })}
    </>
  );
};
export default ElementController;
